import { TemplateColorProperties } from '../../template/types';
import type { CommonAttributeSettings } from '../common';
import { DEFAULT_ATTRIBUTE_SETTINGS, defineMetadata, createAttributeSetter } from '../common';

import {
    createTemplateAttributeGetter,
    createThemeRef,
    isTemplateReference,
    ThemeRefTypes,
    validateTemplateReference,
} from './common';

export const ALPHA_ATTRIBUTE_TYPE = 'alphaAttributeType';

function isValidAlphaValue(value: any): boolean {
    if (typeof value !== 'number') {
        return false;
    }
    if (value < 0) {
        return false;
    }
    if (value > 1) {
        return false;
    }
    return true;
}

function alphaValueValidator(value: any): void {
    if (isTemplateReference(value)) {
        if (!value.includes(ThemeRefTypes.COLORS)) {
            throw Error(`Invalid value for alpha theme ref: ${value}`);
        }
        validateTemplateReference.call(this, value, ThemeRefTypes.COLORS);
    } else if (!isValidAlphaValue(value)) {
        throw Error(`Invalid alpha value: ${value}`);
    }
}

export function templateAlphaByIndex(index: number): string {
    return createThemeRef(ThemeRefTypes.COLORS, index);
}

/**
 * Creates an attribute decorator used to describe a alpha property. This will enforce a numeric
 * value between 0 and 1 or a theme reference string such as themeRef_colors_0.
 */
export function AlphaAttribute(settings: Partial<CommonAttributeSettings> = {}) {
    settings = { ...DEFAULT_ATTRIBUTE_SETTINGS, ...settings };
    return function <This>(
        { get, set }: ClassAccessorDecoratorTarget<This, number>,
        context: ClassAccessorDecoratorContext,
    ): ClassAccessorDecoratorResult<This, number> {
        defineMetadata(settings, ALPHA_ATTRIBUTE_TYPE, context, get);

        return {
            get: createTemplateAttributeGetter(
                get,
                ThemeRefTypes.COLORS,
                TemplateColorProperties.ALPHA,
            ),
            set: createAttributeSetter(alphaValueValidator, get, set),
        };
    };
}
